import api from './api'

export const loggerService = {
  log: async (type: 'auth' | 'subscription' | 'classification', event: string, details: any) => {
    const token = localStorage.getItem("token");
    try {
      await api.post('/logs', {
        type,
        event,
        details,
        timestamp: new Date().toISOString()
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
    } catch (error) {
      console.error('Logging failed:', error);
    }
  }
};
